//https://www.algolia.com/doc/ui-libraries/autocomplete/api-reference/autocomplete-js/autocomplete/
import React from 'react'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import AutoCompleteResultItem from '../AutoCompleteResultItem'
import { algoliaClient } from '../../../lib/algolia'
import AutocompleteListHeader from '../AutocompleteListHeader'
import { baseStatusFilters } from '../../../lib/constants'
import { getCenterProfileSlug } from '../../../domain/center'
import useSegment from '@/hooks/segment/useSegment'
import { navigate } from 'gatsby'
import logger from '@/utils/logger'
import { isNonEmptyArray } from '@/utils/checks'
export const CENTER_SEARCH_SOURCE_ID = 'centerSearch'

const generateAutocompleteCenterSource = ({ indexName, headerTitle }) => {
  const analytics = useSegment()
  return {
    sourceId: CENTER_SEARCH_SOURCE_ID,
    getItems({ query, setContext }) {
      if (!query) {
        return []
      }
      return getAlgoliaResults({
        searchClient: algoliaClient,
        queries: [
          {
            indexName,
            query,
            params: {
              hitsPerPage: 10,
              attributesToRetrieve: [
                'title',
                'slug',
                'status',
                'site',
                'sponsor_tier',
                'featured_image',

                'location_label'
              ],
              filters: baseStatusFilters.join(' AND '),
              attributesToHighlight: ['title'],
              highlightPreTag: '<em>',
              highlightPostTag: '</em>'
            }
          }
        ],
        transformResponse(response) {
          const { hits } = response
          const searchQuery = response.results[0].query
          const result = hits[0].map((center) => {
            const link = getCenterProfileSlug(center)

            return {
              ...center,
              type: 'center',
              link,
              searchQuery: searchQuery
            }
          })
          const noResults = hits.length === 0
          setContext({ increaseLocationsLimit: noResults })

          return result
        }
      })
    },
    onSelect({ item }) {
      try {
        analytics.searchBar.selectCenter({
          center: item.title,
          center_location: item?.location_label,
          sponsor_tier: item.sponsor_tier,
          slug: item.slug,
          zone: 'searchBar',
          searchQuery: item.searchQuery
        })
      } catch (error) {
        logger.error({ message: 'Error in onSelect event', error })
      }
      return navigate(item.link)
    },
    templates: {
      header() {
        return headerTitle ? (
          <AutocompleteListHeader title={headerTitle} />
        ) : null
      },
      item({ item }) {
        return (
          <AutoCompleteResultItem
            result={item}
            aria-label={item.title}
            className="flex min-h-[64px] flex-row px-4 py-[8px]"
          />
        )
      }
    }
  }
}

export default generateAutocompleteCenterSource
